export const odluka_potpora_za_smrt_clana_uze_obitelji_radnika = {
    templateId: 40,
    category: 4,
    templateTitle: "Odluka - potpora za smrt člana uže obitelji radnika",
    templateDescription: `<p>Poslodavac može (odnosno mora, ukoliko ga na to obvezuje pravilnik o radu, kolektivni ugovor i sl.) neoporezivo isplatiti radniku potporu za smrt člana uže obitelji, pri čemu je navedena isplata neoporeziva do visine od 3.000,00 kn.</p>`,
    description: `
    <h5><strong>OPIS DOKUMENTA</strong></h5>
    <p>Pravilnikom o porezu na dohodak propisani su primici koji se ne smatraju plaćom i na koje se ne plaća porez na dohodak - neoporezive isplate.</p>
    <p>U navedene primitke ubraja se i isplata ​potpore za smrt člana uže obitelji radnika (bračnog druga, roditelja, roditelja bračnog druga, djece, drugih predaka i potomaka u izravnoj liniji, posvojene i udomljene djece i djece na skrbi te punoljetne osobe kojoj je porezni obveznik imenovan skrbnikom prema posebnom zakonu).</p>
    <p>Navedena potpore ne podliježe oporezivanju ukoliko nije veća od 3.000,00 kuna.</p>
    <p>Potpora za člana uže obitelji radnika smatra se materijalnim pravom radnika, a koje nije izravno propisano Zakonom o radu, nego se po potrebi uređuje kolektivnim ugovorom, pravilnikom o radu ili ugovorom o radu.</p>
    <p>Međutim, ukoliko navedeno pravo nije propisano pravilnikom o radu ili kolektivnim ugovorom odnosno ako nije određeno ugovorom o radu, onda poslodavac samostalno odlučuje hoće li to pravo omogućiti radniku i u kojem opsegu (u cijelosti ili djelomično).</p>
    <p>Također, potpora za smrt člana uže obitelji je za poslodavca porezno priznati trošak s aspekta utvrđivanja osnovice poreza na dobit, no samo do gore navedenog iznosa od 3.000,00 kn.</p>
    <p>Osim toga, prema odredbama Ovršnog zakona, potpora za smrt člana uže obitelji do propisanog neoporezivog iznosa primitka po osnovi nesamostalnog rada izuzeta je od ovrhe te se u slučaju blokade računa radnika uplaćuje se na račun radnika koji je zaštićen od ovrhe na novčanim sredstvima (tzv. zaštićeni račun).</p>
    <p>Međutim, ovaj primitak je izuzet od ovrhe samo do propisanih iznosa do kojih se smatraju neoporezivim primicima po osnovi od nesamostalnog rada, što znači da se u dijelu u kojem se smatraju oporezivim primicima po osnovi od nesamostalnog rada ne mogu isplatiti na zaštićeni, već na redovni račun.</p>
    <p>Poslodavac može potporu za smrt člana uže obitelji isplatiti radniku u gotovini iz blagajne ili na tekući račun, a isplata može biti obavljena uz isplatu redovne plaće ili posebno.</p>
    <p><strong>NAJČEŠĆE GREŠKE</strong></p>
    <p><strong>- Isplaćivanje naknade za smrt osobe koja nije član obitelji</strong></p>
    <p>Pojašnjenje: članom uže obitelji smatraju se osobe koje su označene kao takve sukladno Pravilniku o porezu na dohodak te je neoporezivo moguće isplatiti samo za tako naznačene osobe.</p>
    <h5><strong>PRAVNA OSNOVA</strong></h5>
    <p>Zakon o porezu na dohodak, Pravilnik o porezu na dohodak, Ovršni zakon.</p>
  `,
    sides: [
        {
            prefix: 'Na temelju Zakona o porezu na dohodak i Pravilnika o porezu na dohodak,',
            signature: 'Za Poslodavca:',
            inputs: [{
                type: "input",
                required: true,
                placeholder: "Poslovni subjekt",
              },
              {
                type: "input",
                required: true,
                placeholder: "Ulica i kućni broj",
              },
              {
                type: "input",
                required: true,
                placeholder: "Mjesto",
              },
              {
                type: "input",
                required: true,
                placeholder: "OIB",
              },
              {
                type: "input",
                placeholder: "Zastupa",
                inSignature: true,
              },
              {
                type: "input",
                placeholder: "Funkcija",
                inSignature: true,
              }],
              suffix: ' (u daljnjem tekstu: Poslodavac),',
        }
    ],

    headline: 'donosi sljedeću',
    title: ' ODLUKU O ISPLATI POTPORE ZA SMRT ČLANA OBITELJI ',
    noArticleNumbers: true,

    articles: [
        {
            title: '',
            mandatory: true,

            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Dana'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'godine,'},
                        { type: 'input', value: '', required: true, placeholder: "Ime i prezime" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'iz',},
                        { type: 'input', value: '', required: true, placeholder: "Mjesto"   },
                        { type: 'text', content: ',' },
                        { type: 'input', value: '', required: true, placeholder: "Ulica i kućni broj" },
                        { type: "text", content: "," },
                        { type: 'text', content: 'OIB:' },
                        { type: "input",  required: true,},
                        {type: 'text', content: ', (u daljnjem tekstu: Radnik), umro je član uže obitelji, što je imenovani potvrdio dostavljanjem preslike Izvatka iz matice umrlih te preostalom dokumentacijom kojom se dokazuje da je umrla osoba bila član uže obitelji Radnika.'},
                    ],
                },
              ],
                help: 'Neoporeziva isplata potpore dopuštena je samo za smrt člana uže obitelji. U gornjem tekstu možete vidjeti koje osobe se smatraju članom uže obitelji.',
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    editable: true,
                    mandatory: true,
                    content: 'Imenovani Radnik je smrt osobe člana uže obitelji potvrdio dostavljanjem preslike Izvatka iz matice umrlih te preostalom dokumentacijom kojom se dokazuje da je umrla osoba bila član uže obitelji Radnika. ',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: false,
                    parts: [
                        {type: 'text', content: 'S obzirom na navedeno u ovoj Odluci, Poslodavac je odlučio isplatiti Radniku potporu za smrt člana uže obitelji u iznosu od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'kn.'}],
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'input',
                    mandatory: true,
                    editable: true,
                    parts: [
                        {type: 'text', content: 'Potpora se isplaćuje u roku od'},
                        {type: 'input', value: '', required: true},
                        {type: 'text', content: 'dana od dana donošenja ove Odluke.'}],
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'choice',
                    mandatory: true,
                    editable: true,
                    choices: [
                        'Potpora iz ove Odluke isplaćuje se na redovan račun Radnika, no u slučaju da Radnik ima otvoren zaštićeni račun, sredstva se doznačuju na zaštićeni račun.',
                        'Poslodavac će potporu iz ove Odluke Radniku isplatiti u gotovini.'
                    ],
                    placeholder: "Odaberite ovdje te potom izmijenite po želji...",
                }
            ]
        },
        {
            title: '',
            mandatory: false,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Ukoliko postoji zakonska mogućnost  korištenja neoporezive isplate, pri isplati potpore za smrt člana uže obitelji iskoristiti će se ta porezna mogućnost. ',
                    value: '',
                }],
        },
        {
            title: '',
            mandatory: true,
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Odluka se primjenjuje s danom donošenja.',
                    value: '',
                }],
        },
        {
            mandatory: true,
            static: true,
            type: 2, // date and place
            statements: [
              {
                type: "input",
                mandatory: true,
                parts: [
                  {
                    type: "text",
                    content: "U"
                  },
                  {
                    type: "input",
                    value: "",
                    placeholder: "Upišite mjesto.",
                    required: true,
                  },
                  {
                    type: "text",
                    content: ", dana"
                  },
                  {
                    type: "date",
                    value: new Date(),
                    required: true
                  },
                  {
                    type: "text",
                    content: "godine."
                  }
                ]
              },
            ]
          },
        {
            mandatory: true,
            static: true,
            type: 3,  // signatures
            statements: [],
        },
        {
            static: true,
            mandatory: false,
            type: 4, 
            statements: [
                {
                    type: 'text',
                    mandatory: true,
                    editable: true,
                    content: 'Dostaviti:\r\n1) Radniku\r\n2) Kadrovska služba \r\n3) Obračun plaća',
                    help: 'Po želji, slobodno dopišite kome želite dostaviti odluku odnosno izmijenite/obrišite predložene unose.'
                }
            ]
        },
    ],
};


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/40_odluka_potpora_za_smrt_clana_uze_obitelji_radnika.ts